export class SpecialNightRate {
  programId: string;
  typeIndicator: string;
  certificateNumber: string;

  constructor(typeIndicator?: string, certificateNumber?: string) {
    this.typeIndicator = typeIndicator;
    this.certificateNumber = certificateNumber;
    this.programId = 'PC';
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/special-night-rate/special-night-rate.model.ts